export const srcSet = (src) => `${src.replace("-1400.webp", "-800.webp")} 800w, ${src} 1400w`;

export const Photo = ({ src, alt, className, sizes = "(max-width: 640px) 100vw, 50vw", priority = false, ...rest }) => (
  <img
    src={src}
    srcSet={srcSet(src)}
    sizes={sizes}
    alt={alt}
    className={className}
    loading={priority ? "eager" : "lazy"}
    decoding="async"
    fetchPriority={priority ? "high" : "auto"}
    {...rest}
  />
);
